<ng-container *ngIf="localeOptions.length > 0 && !!selectedLocaleOption">
  <div
    class="locale-selector"
    [ngClass]="{
      'dark-mode': colorScheme === ColorScheme.Dark,
      'is-mobile': isMobile
    }"
    (click)="toggleMenuDropDown()"
  >
    <div
      class="locale-selector-container"
      [ngClass]="{
        'is-expanded': isMenuDropDownOpen
      }"
    >
      <div class="locale-selector-circle">
        <img [src]="selectedLocaleOption.flagUrl" alt="Selected Locale Flag" />
      </div>
      <div class="locale-selector-label" *ngIf="!isMobile">
        <span>{{ selectedLocaleOption.name }}</span>
        <div class="arrow-icon">
          <i class="icon icon-dropdown"></i>
        </div>
      </div>
    </div>

    <div
      class="locale-selector-menu-drop-down"
      [ngClass]="{
        'is-expanded': isMenuDropDownOpen,
        'is-placed-left': dropDownPlacement === 'left',
        'is-placed-right': dropDownPlacement === 'right'
      }"
    >
      <ul>
        <li
          *ngFor="let localeOption of localeOptions"
          (click)="onSelectLocale(localeOption)"
          [ngClass]="{
            selected: localeOption.code === selectedLocaleOption.code
          }"
        >
          <div class="locale-selector-circle">
            <img [src]="localeOption.flagUrl" alt="Locale Flag" />
          </div>
          <span>{{ localeOption.name }}</span>
        </li>
      </ul>
    </div>
  </div>
</ng-container>
